import { render, staticRenderFns } from "./stats_analytics.vue?vue&type=template&id=50b63910&"
import script from "./stats_analytics.vue?vue&type=script&lang=js&"
export * from "./stats_analytics.vue?vue&type=script&lang=js&"
import style0 from "./stats_analytics.vue?vue&type=style&index=0&id=50b63910&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports